module.exports = __webpack_public_path__ + "img/full6-min.5721c46e.png";